import { IconStyles } from '../types'
import { ExpandCustom } from './styles'

interface ExpandProps extends IconStyles {
  onClick: any
  isExpanded: boolean
}

export const ExpandIcon = ({
  onClick,
  cursor,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  colorIcon,
  isExpanded
}: ExpandProps) => {
  return (
    <ExpandCustom
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      cursor={cursor}
      onClick={onClick}
      colorIcon={colorIcon}
      isExpanded={isExpanded}
    />
  )
}
